import { createBrowserRouter } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
import Home from './pages/Home';
import Manifest from './pages/Manifest';
import Principles from './pages/Principles';
import Library from './pages/Library';
import LibraryDocument from './pages/LibraryDocument';
import Apply from './pages/Apply';
import Withdraw from './pages/Withdraw';
import Status from './pages/Status';
import Login from './pages/Login';
import AuthVerify from './pages/AuthVerify';
import Account from './pages/Account';
import Profile from './pages/Profile';
import Privacy from './pages/Privacy';
import ApprovalQueue from './pages/ApprovalQueue';
import MemberRegister from './pages/MemberRegister';
import MemberDetail from './pages/MemberDetail';
import Meetings from './pages/Meetings';
import MeetingDetail from './pages/MeetingDetail';
import Finances from './pages/Finances';
import Donate from './pages/Donate';
import DonateThanks from './pages/DonateThanks';
import DonateSwish from './pages/DonateSwish';
import DonateRecurringManage from './pages/DonateRecurringManage';
import Donations from './pages/Donations';
import NotFound from './pages/NotFound';

/** Public routes (FR-015) + the tokened withdraw route. All render inside the branded SiteLayout. */
export const router = createBrowserRouter([
  {
    element: <SiteLayout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/manifest', element: <Manifest /> },
      { path: '/principles', element: <Principles /> },
      { path: '/library', element: <Library /> },
      { path: '/library/:slug', element: <LibraryDocument /> },
      { path: '/apply', element: <Apply /> },
      { path: '/withdraw/:token', element: <Withdraw /> },
      { path: '/login', element: <Login /> },
      { path: '/auth/verify', element: <AuthVerify /> },
      { path: '/account', element: <Account /> },
      { path: '/profile', element: <Profile /> },
      { path: '/privacy', element: <Privacy /> },
      { path: '/board/queue', element: <ApprovalQueue /> },
      { path: '/members', element: <MemberRegister /> },
      { path: '/members/:id', element: <MemberDetail /> },
      { path: '/meetings', element: <Meetings /> },
      { path: '/meetings/:id', element: <MeetingDetail /> },
      { path: '/finances', element: <Finances /> },
      { path: '/donate', element: <Donate /> },
      { path: '/donate/thanks', element: <DonateThanks /> },
      { path: '/donate/swish/:ref', element: <DonateSwish /> },
      { path: '/donate/recurring/manage/:token', element: <DonateRecurringManage /> },
      { path: '/board/donations', element: <Donations /> },
      { path: '/status', element: <Status /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
